'use es6';

var tracker;
export var setTracker = function setTracker(_tracker, override) {
  if (tracker && !override) {
    throw new Error('Attempting to override an existing usage tracker.');
  }

  tracker = _tracker;
};
export var getTracker = function getTracker() {
  if (!tracker) {
    throw new Error('No tracker was set. Make sure setTracker was called.');
  }

  return tracker;
};
export var getBeforeUnloadTracker = function getBeforeUnloadTracker() {
  return getTracker().clone({
    isBeforeUnload: true
  });
};